(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cz-v2-review-wall"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cz-review-wall')) {
    customElements.define(
      'cz-review-wall',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return
          this.dataset.ready = 'true'
          this.reviews = JSON.parse(this.querySelector('[data-reviews-json]').textContent)
          this.filteredReviews = this.reviews
          this.initialCount = Number(this.dataset.initialCount) || 6
          this.visibleCount = this.initialCount
          this.grid = this.querySelector('[data-review-grid]')
          this.moreButton = this.querySelector('[data-review-more]')
          this.status = this.querySelector('[data-review-status]')
          this.querySelectorAll('[data-review-filter]').forEach((button) => {
            button.addEventListener('click', () => this.applyFilter(button))
          })
          this.moreButton.addEventListener('click', () => this.toggleMore())
          this.render()
        }

        applyFilter(activeButton) {
          this.querySelectorAll('[data-review-filter]').forEach((button) => {
            button.setAttribute('aria-pressed', String(button === activeButton))
          })
          const filter = activeButton.dataset.reviewFilter
          this.filteredReviews = filter === 'all' ? this.reviews : this.reviews.filter((review) => String(review.stars) === filter)
          this.visibleCount = this.initialCount
          this.render()
        }

        toggleMore() {
          const isExpanded = this.visibleCount >= this.filteredReviews.length
          this.visibleCount = isExpanded ? this.initialCount : Math.min(this.visibleCount + 9, this.filteredReviews.length)
          this.render()
          if (isExpanded) this.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }

        render() {
          const fragment = document.createDocumentFragment()
          this.filteredReviews.slice(0, this.visibleCount).forEach((review) => fragment.append(this.createCard(review)))
          this.grid.replaceChildren(fragment)
          const isExpanded = this.visibleCount >= this.filteredReviews.length
          this.status.textContent = `${this.filteredReviews.length} avis`
          this.moreButton.hidden = this.filteredReviews.length <= this.initialCount
          this.moreButton.dataset.expanded = String(isExpanded)
          this.moreButton.querySelector('span').textContent = isExpanded ? this.dataset.lessLabel : this.dataset.moreLabel
        }

        createCard(review) {
          const card = document.createElement('article')
          card.className = 'czv2-review-wall__card'

          const top = document.createElement('div')
          top.className = 'czv2-review-wall__card-top'
          const stars = document.createElement('span')
          stars.className = 'czv2-review-wall__card-stars'
          stars.setAttribute('aria-label', `${review.stars} étoiles sur 5`)
          stars.textContent = `${'★'.repeat(review.stars)}${'☆'.repeat(5 - review.stars)}`
          const tag = document.createElement('span')
          tag.className = 'czv2-review-wall__card-tag'
          tag.textContent = review.tag
          top.append(stars, tag)

          const quote = document.createElement('blockquote')
          quote.textContent = `« ${review.text} »`

          const author = document.createElement('footer')
          author.className = 'czv2-review-wall__author'
          const avatar = document.createElement('span')
          avatar.className = 'czv2-review-wall__avatar'
          avatar.setAttribute('aria-hidden', 'true')
          avatar.textContent = review.name.split(/\s+/).map((part) => part.charAt(0)).join('').slice(0, 2).toUpperCase()
          const authorCopy = document.createElement('span')
          const name = document.createElement('strong')
          name.textContent = review.name
          const verified = document.createElement('small')
          verified.textContent = this.dataset.verifiedLabel
          authorCopy.append(name, verified)
          author.append(avatar, authorCopy)

          card.append(top, quote, author)
          return card
        }
      }
    )
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cz-v3-review-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cz-review-carousel')) {
    customElements.define(
      'cz-review-carousel',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return
          this.dataset.ready = 'true'

          const featured = JSON.parse(this.querySelector('[data-featured-reviews-json]').textContent)
          const legacyNode = this.querySelector('[data-legacy-review-source] [data-reviews-json]')
          const legacy = legacyNode ? JSON.parse(legacyNode.textContent) : []
          this.reviews = [...featured, ...legacy]
          this.viewport = this.querySelector('[data-review-viewport]')
          this.track = this.querySelector('[data-review-track]')
          this.previousButton = this.querySelector('[data-review-previous]')
          this.nextButton = this.querySelector('[data-review-next]')
          this.status = this.querySelector('[data-review-status]')

          this.render()
          this.querySelector('[data-legacy-review-source]')?.remove()
          this.previousButton.addEventListener('click', () => this.move(-1))
          this.nextButton.addEventListener('click', () => this.move(1))
          this.viewport.addEventListener('scroll', () => this.queueControls(), { passive: true })
          window.addEventListener('resize', () => this.queueControls(), { passive: true })
          this.updateControls()
        }

        render() {
          const fragment = document.createDocumentFragment()
          this.reviews.forEach((review) => fragment.append(this.createCard(review)))
          this.track.replaceChildren(fragment)
        }

        createCard(review) {
          const card = document.createElement('article')
          card.className = 'czv3-review-carousel__card'

          if (review.image) {
            const media = document.createElement('div')
            media.className = 'czv3-review-carousel__media'
            const image = document.createElement('img')
            image.src = review.image
            image.alt = review.alt || ''
            image.loading = 'lazy'
            image.decoding = 'async'
            media.append(image)
            card.append(media)
          }

          const body = document.createElement('div')
          body.className = 'czv3-review-carousel__body'
          const head = document.createElement('div')
          head.className = 'czv3-review-carousel__card-head'
          const stars = document.createElement('span')
          stars.className = 'czv3-review-carousel__stars'
          stars.setAttribute('aria-label', `${review.stars} étoiles sur 5`)
          stars.textContent = `${'★'.repeat(review.stars)}${'☆'.repeat(5 - review.stars)}`
          const tag = document.createElement('span')
          tag.className = 'czv3-review-carousel__tag'
          tag.textContent = review.tag
          head.append(stars, tag)

          const quote = document.createElement('blockquote')
          quote.textContent = `« ${review.text} »`

          const author = document.createElement('footer')
          author.className = 'czv3-review-carousel__author'
          const avatar = document.createElement('span')
          avatar.className = 'czv3-review-carousel__avatar'
          avatar.setAttribute('aria-hidden', 'true')
          avatar.textContent = review.name.split(/\s+/).map((part) => part.charAt(0)).join('').slice(0, 2).toUpperCase()
          const copy = document.createElement('span')
          const name = document.createElement('strong')
          name.textContent = review.name
          const verified = document.createElement('small')
          verified.textContent = this.dataset.verifiedLabel
          copy.append(name, verified)
          author.append(avatar, copy)
          body.append(head, quote, author)
          card.append(body)
          return card
        }

        move(direction) {
          const card = this.track.querySelector('.czv3-review-carousel__card')
          if (!card) return
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0
          this.viewport.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' })
          this.status.textContent = direction > 0 ? 'Avis suivant affiché' : 'Avis précédent affiché'
        }

        queueControls() {
          cancelAnimationFrame(this.frame)
          this.frame = requestAnimationFrame(() => this.updateControls())
        }

        updateControls() {
          const maximum = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth)
          this.previousButton.disabled = this.viewport.scrollLeft <= 2
          this.nextButton.disabled = this.viewport.scrollLeft >= maximum - 2
        }
      }
    )
  }
  } catch(e) { console.error(e); }
})();

})();
